module.exports = __webpack_public_path__ + "static/media/CEDIA-preparacion-masato.5a82ec8d.JPG";